document.addEventListener( 'DOMContentLoaded', function() {
	var cards = document.querySelectorAll( '.flip-card-container' );
	// Exit early if no .flip-card-container elements are found
	if ( cards.length === 0 ) return;		
	cards.forEach( function( card ) {
		card.addEventListener( 'click', function() {
			this.querySelector( '.flip-card-inner' ).classList.toggle( 'is-flipped' );
		} );
	} );
} );